import React from 'react';
import { Car, MapPin, Calculator, Shield, Star, Heart, Phone } from 'lucide-react';

export default function HowItWorks() {
  const steps = [
    {
      icon: MapPin,
      title: "Konumunuzu Belirleyin",
      description: "Size en yakın taksi durağını bulmak için konumunuzu paylaşın veya manuel olarak adres seçin."
    },
    {
      icon: Car,
      title: "En Yakın Taksiyi Bulun",
      description: "Sistemimiz size en yakın ve müsait taksi duraklarını anında gösterir."
    },
    {
      icon: Calculator,
      title: "Ücreti Hesaplayın",
      description: "Yolculuk öncesi tahmini taksi ücretini hesaplayarak sürprizlerle karşılaşmayın."
    },
    {
      icon: Phone,
      title: "Taksi Çağırın",
      description: "Seçtiğiniz taksi durağını tek tıkla arayarak taksinizi çağırın."
    }
  ];

  const features = [
    {
      icon: Shield,
      title: "Güvenli Yolculuk",
      description: "Tüm taksi durakları ve şoförler resmi olarak kayıtlı ve denetlenmektedir."
    },
    {
      icon: Star,
      title: "Kullanıcı Değerlendirmeleri",
      description: "Gerçek kullanıcı yorumları ve puanlamalarıyla en iyi hizmeti alın."
    },
    {
      icon: Heart,
      title: "Favori Duraklar",
      description: "Sık kullandığınız taksi duraklarını favorilere ekleyerek hızlıca erişin."
    }
  ];

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto space-y-16">
        {/* Hero Section */}
        <div className="text-center space-y-4">
          <h1 className="text-3xl md:text-4xl font-bold text-white">
            En Yakın Taksi Nasıl Çalışır?
          </h1>
          <p className="text-gray-400 text-lg">
            Size en yakın taksi durağını bulmanın en kolay yolu
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                    <Icon className="w-6 h-6 text-gray-900" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">
                      {step.title}
                    </h3>
                    <p className="text-gray-400">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Features */}
        <div>
          <h2 className="text-2xl font-bold text-white text-center mb-8">
            Neden Bizi Tercih Etmelisiniz?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5 text-center">
                  <div className="flex flex-col items-center gap-4">
                    <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
                      <Icon className="w-6 h-6 text-gray-900" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-white mb-2">
                        {feature.title}
                      </h3>
                      <p className="text-gray-400">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}